import DashboardLayout from '../layouts/DashboardLayout'
// import Setting from '../pages/settings/SettingList'
// import SettingV1 from '../pages/settings/SettingListV1'

export const settingMenu = {
  path: '/setting',
  component: DashboardLayout,
  name: 'Setting',
  // redirect: '/setting',
  children: [
    {
      path: '/setting/contact',
      // name: 'Settings',
      component: () => import (/* webpackChunkName: "about" */'../pages/settings/SettingList.vue'),
      meta: {
        roles: ['setting-contact_read', 'setting-contact_update'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Phân bổ contact'
        }]
      },
    },
    {
      path: '/setting/contact-v1',
      // name: 'Settings',
      component: () => import (/* webpackChunkName: "about" */'../pages/settings/SettingListV1.vue'),
      meta: {
        roles: ['setting-contact_read', 'setting-contact_update'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Phân bổ contact riêng'
        }]
      }
    },
    {
      path: 'org-machine/struct',
      name: 'Organization Machine',
      component: () => import (/* webpackChunkName: "about" */'../pages/organization-machine/OrganizationMachine'),
      meta: {
        roles: ['setting-organization_read', 'setting-organization_create', 'setting-organization_update', 'setting-organization_delete'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Tổ chức bộ máy',
        }]
      }
    },
    {
      path: 'org-machine/employee-manager',
      name: 'Employee Manager',
      component: () => import (/* webpackChunkName: "about" */'../pages/users/UserList'),
      meta: {
        roles: ['user_read', 'user_create', 'user_update', 'user_delete', 'user_view_all'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Quản lý nhân sự',
        }]
      }
    },
    {
      path: 'org-machine/kpi-manager',
      name: 'KPI Manager',
      component: () => import (/* webpackChunkName: "about" */'../pages/indicator/Indicator'),
      meta: {
        roles: ['setting-kpi_read', 'setting-kpi_create', 'setting-kpi_update', 'setting-kpi_delete'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Quản lý KPI',
        }]
      }
    },
    {
      path: 'org-machine/rank-manager',
      name: 'Rank Manager',
      component: () => import (/* webpackChunkName: "about" */'../pages/rank/RankList'),
      meta: {
        roles: ['setting-rank_read', 'setting-rank_update'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Quản lộ trình làm việc',
        }]
      }
    },
    {
      path: 'role',
      name: 'RoleList',
      component: () => import(/* webpackChunkName: "about" */'../pages/roles/TopicList.vue'),
      meta: {
        roles: ['setting-role_read','setting-role_create','setting-role_update','setting-role_delete'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách quyền',
        }]
      },
    },
    {
      path: 'create-role',
      name: 'CreateRole',
      component: () => import(/* webpackChunkName: "about" */'../pages/roles/RoleForm.vue'),
      meta: {
        roles: ['setting-role_create'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách quyền',
          to: '/setting/role'
        }, {
          title: 'Tạo mới quyền',
        }]
      },
    },
    {
      path: 'role/edit/:id',
      name: 'EditRole',
      component: () => import(/* webpackChunkName: "about" */'../pages/roles/RoleForm.vue'),
      meta: {
        roles: ['setting-role_update'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách quyền',
          to: '/setting/role'
        }, {
          title: 'Chỉnh sửa quyền',
        }]
      },
    },
  ],
}